export default __webpack_public_path__ + "static/media/Mark-2-HUD-Weather Widget.65e14f69.jpg";